import { getQuickSubmitCandidates } from '../../../../services/candidatesApi';
import { getJobList } from '../../../../services/dropdownApi';

export const api = {
  searchOptions: async (field, search, context) => {
    if (field.searchFetchKey === 'quickSubmitJobList') {
      const record = context.selectedRecords?.[0] ?? {};
      const candidateId = record.id ?? record._id ?? context.selectedIds?.[0];
      const response = await getJobList({ searchQuery: search, candidateId });
      const list = Array.isArray(response?.data) ? response.data : [];
      return list.map((item) => ({
        label: [item.jobReferenceId, item.jobTitle].filter(Boolean).join(' - ') || String(item._id ?? ''),
        value: item._id ?? '',
      }));
    }
    if (field.searchFetchKey === 'quickSubmitCandidates') {
      const record = context.selectedRecords?.[0] ?? {};
      const jobId =
        context.jobId ?? record.jobId ?? record.id ?? record._id ?? context.selectedIds?.[0];
      return getQuickSubmitCandidates({
        isFromSubmission: context.isFromSubmission,
        jobId,
        submissionId: context.submissionId,
        search,
      });
    }
    return [];
  },
  submit: async (values, context) => {
    const { navigate, selectedRecords = [], selectedIds = [], moduleName, isFromSubmission = false } = context;
    const record = selectedRecords[0] ?? {};

    if (moduleName === 'candidate') {
      const jobId = values.jobId ?? '';
      const candidateId = record.id ?? record._id ?? selectedIds[0] ?? '';
      navigate(`/submission-create/${jobId}?candidateId=${candidateId}&isFromSubmission=${isFromSubmission}`);
    } else {
      const jobId = context.jobId ?? record.jobId ?? record.id ?? record._id ?? selectedIds[0] ?? '';
      const candidateId = values.candidate ?? '';
      navigate(`/submission-create/${jobId}?candidateId=${candidateId}&isFromSubmission=${isFromSubmission}`);
    }
    return { navigated: true };
  },
};
